import {
  Box,
  Heading,
} from '@chakra-ui/react';
import TabbedSubnav from '@src/components/shared/TabbedSubnav';

export default function MainNav() {
  return (
    <Box p={4}>
      <Heading as="h1">Content Management</Heading>
      <TabbedSubnav
        tabs={[{ label: 'Home Page', path: 'home' }]}
        mt={4}
      />
    </Box>
  );
}
